import { css } from 'linaria';
import { ModalMediaCardStructure } from 'common/components';
import { INTERIOR_DOORS_CDN_PATH } from '../../interior-doors-constants';

export type InteriorDoorsMoreInfoCardStructure = {
  imgSrc: string;
  modalImgSrc: string;
  modalImgClassName?: string;
  description: string;
  title: string;
  name?: string;
};

export const INTERIOR_DOORS_TRENDS_CARD_LIST: ModalMediaCardStructure<InteriorDoorsMoreInfoCardStructure>[] = [
  {
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/trends/1.jpg/1.jpg`,
    modalImgSrc: `${INTERIOR_DOORS_CDN_PATH}/trends-popup/1.jpg/1.jpg`,
    title: 'Скрытые\u00A0двери',
    name: 'Скрытые двери',
    description:
      'Двери скрытого монтажа, или \xABдвери-невидимки\xBB, подойдут любителям минимализма и\u00A0пространства.\n' +
      'Дверная коробка и\u00A0полотно без наличников монтируются на\u00A0уровне со\u00A0стеной, что визуально увеличивает помещение.\n' +
      'Для создания полностью невидимого эффекта скрытые двери могут быть отделаны обоями и\u00A0шпаклёвкой в\u00A0едином со\u00A0стеной стиле. А\u00A0для акцента можно выбрать контрастные оттенки для стены и\u00A0дверного полотна.',
  },
  {
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/trends/2.jpg/2.jpg`,
    modalImgSrc: `${INTERIOR_DOORS_CDN_PATH}/trends-popup/2.jpg/2.jpg`,
    modalImgClassName: css`
      @media (--only-desktop) {
        object-position: right center;
      }
    `,
    title: 'Двери с\u00A0алюминиевой\u00A0кромкой',
    name: 'Двери с алюминиевой кромкой',
    description:
      'Двери с\u00A0алюминиевой кромкой\u00A0\u2014 надёжное и\u00A0функциональное решение. Алюминиевая кромка придаёт дверям привлекательный вид и\u00A0защищает от\u00A0механических повреждений и\u00A0износа. \n' +
      'Алюминий устойчив к\u00A0коррозии, его легко очищать специальными средствами. Кромка обеспечивает высокую жёсткость полотна, сохраняет строгую геометрическую форму. \n' +
      'Такие двери гармонично дополнят интерьер в\u00A0современном и\u00A0классическом стиле.',
  },
  {
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/trends/3.jpg/3.jpg`,
    modalImgSrc: `${INTERIOR_DOORS_CDN_PATH}/trends-popup/3.jpg/3.jpg`,
    modalImgClassName: css`
      @media (--only-desktop) {
        object-position: left center;
      }
    `,
    title: 'Классический\u00A0дизайн дверей',
    name: 'Классический дизайн дверей',
    description:
      'Межкомнатные двери в\u00A0классическом стиле универсальны. Могут быть выполнены из\u00A0различных материалов с\u00A0отделкой из\u00A0натурального дерева или её\u00A0имитацией или покрытых высококачественной эмалью.\n' +
      'В\u00A0нашем ассортименте также представлены однотонные двери с\u00A0гладкой поверхностью, с\u00A0остеклением и\u00A0без. \n' +
      'Это надёжный и\u00A0красивый выбор для любого классического и\u00A0современного интерьера.',
  },
  {
    imgSrc: `${INTERIOR_DOORS_CDN_PATH}/trends/4.jpg/4.jpg`,
    modalImgSrc: `${INTERIOR_DOORS_CDN_PATH}/trends-popup/4.jpg/4.jpg`,
    modalImgClassName: css`
      @media (--only-desktop) {
        object-position: right center;
      }
    `,
    title: 'Раздвижные\u00A0двери',
    name: 'Раздвижные двери',
    description:
      'Скрытые раздвижные двери, также известные как \xABдвери-пеналы\xBB, помогут эффективно использовать пространство. Они позволяют скрыть проходы и\u00A0не\u00A0занимают места.\n' +
      'При монтаже скрытых раздвижных дверей в\u00A0стену встраивается каркас\u00A0\u2014 \xABпенал\xBB, в\u00A0который будут задвигаться дверные полотна.\n' +
      'Такие двери отлично впишутся практически в\u00A0любой интерьер и\u00A0придадут ему актуальный и\u00A0стильный вид.',
  },
];
